import { IsoMonth } from '@aloft/toolkit-shared/lib/syntax/fnma';

export function toIsoMonth(year: number, month: number): IsoMonth {
  return (year + '-' + month.toString().padStart(2, '0')) as IsoMonth;
}
